export default __webpack_public_path__ + "static/media/typescript-logo.046fa532.png";